import { render, staticRenderFns } from "./ImportacaoDocEdi.vue?vue&type=template&id=1587ae4d"
import script from "./ImportacaoDocEdi.vue?vue&type=script&lang=js"
export * from "./ImportacaoDocEdi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports